<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M15.25 3.25V10.3731V15.9961C15.25 16.6035 14.5657 16.959 14.0687 16.6097L10.8626 14.3562C10.345 13.9925 9.655 13.9925 9.13743 14.3562L5.93127 16.6097C5.43432 16.959 4.75 16.6035 4.75 15.9961V3.25" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7.1875 3.25H12.8125M9.0625 8.6875H10.9375M8.125 6.0625H11.875" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {
  name: 'SavedFiltersIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>